export const findKeyInObject = (structure: any, key: string): string =>
  key.split('.').reduce((previous, key) => previous && previous[key], structure) || ''
